import React from 'react';
import { useHistory } from "react-router-dom";
import { styled } from '@mui/material/styles';
import {Box, Grid, Link} from '@material-ui/core';
import LinearProgress from '@mui/material/LinearProgress';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import DialogTestDetails from '../components/DialogTestDetails';
import DialogTestStart from '../components/DialogTestStart';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy";
import LeftDrawer from "../components/LeftDrawer";
import NotificationAlerts from "../components/NotificationAlerts";
import {API_URL} from '../utils/EnvVars';
import '../styles/bizofficer-a.css';
///import 'font-awesome/css/font-awesome.min.css';
import { useDispatch, useSelector } from 'react-redux';
///import { setTopicTree, setTopicList, setKeywordList, setTopicTreeLearning, setTopicListLearning, setKeywordListLearning, setTopicTreeTest, setTopicListTest, setSmartLearning, setMockTest } from '../store/data.actions';
import { setTopicTree, setTopicList, setKeywordList, setTopicTreeLearning, setTopicListLearning, setKeywordListLearning, setLearningContents, setTopicTreeTest, setTopicListTest, setMockTest, setContentLimit } from '../store/data.actions';
import Cookies from "js-cookie";
import NewTutorialButton from '../components/StudentTutorial/NewStudentTutorial';
import StudyMaterialHelpVideoButton from '../components/StudyMaterialHelpVideoButton/StudyMaterialHelpVideoButton';
//import {setPopup } from "../store/popup.actions";


const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	},
	padding: theme.spacing(1),
},
}));

const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
	border: `1px solid ${theme.palette.divider}`,
		  
	  borderRadius: 10,
	  marginBottom: 10,
	  backgroundColor: '#F7F7F7',
	
	  '&:before': {
		  display: 'none',
	},
}));

const AccordionSummary = styled((props) => (
	<MuiAccordionSummary
	expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' , color: '#000000' }} />}
	{...props}
	/>
))(({ theme }) => ({
	// backgroundColor: '#1f407a',
	// color: '#FFFFFF',
	flexDirection: 'row-reverse',
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginLeft: theme.spacing(1),
	},
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	  borderTop: '1px solid rgba(0, 0, 0, .125)',
	}));
	
	export default function Execute() {
		const popup1 = useSelector((state => state?.popup1))
		///const ftue = Cookies.get("ftue");
		const dataObj = useSelector(state => state.getData);
		const dispatch = useDispatch();
		const classes = useStyles();
	let history = useHistory();
	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));	
	var selectedCourse = localStorage.getItem('etlSelectCourse'); 
	var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));
	const childRef = React.useRef();
	const childRefStartTest = React.useRef();
	const [showProgress, setShowProgress] = React.useState(false);
	const [expanded, setExpanded] = React.useState('panel100');
	const [testDetail, setTestDetail] = React.useState({});
	const [currentRunningTestTitle, setCurrentRunningTestTitle] = React.useState("");
	const [currentRunningTestSession, setCurrentRunningTestSession] = React.useState("");
	const [testType, setTestType] = React.useState(3);

	// Help Video Icon State
	const [isHelpVideoOpen, setIsHelpVideoOpen] = React.useState(false);

	////const [mockTestList, setMockTestList] = React.useState([]);

	const authResult = new URLSearchParams(window.location.search);
	const deviceType = authResult.get('device_type');



  	if(deviceType && deviceType.length>0){
    	localStorage.setItem("deviceType", deviceType);
  	}
	
	// check if logged in
	if(localStorage.getItem('etlStudentObj')===null){
		history.push('login');	
	}

	const handleChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false);
	};

	function showDetails(obj){
		///alert(JSON.stringify(obj));
		setTestDetail(obj);
		childRef.current.handleClickOpen();		
	}
	function startMyTest(){
		///alert("aaaa");
		if(selectedCourse>=0 && mySelectedCourses[selectedCourse].templateId){
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};
			axios.get(API_URL+'/testcurrentrunning?templateId='+mySelectedCourses[selectedCourse].templateId, axiosHeader)
				.then(response => {
					///console.log("Just Checking >> "+response.data);
					if(response.data.responseTxt=="success"){
						setCurrentRunningTestTitle(response.data.testName);
						setCurrentRunningTestSession(response.data.testSession);
						setTestType(response.data.testType);
						childRefStartTest.current.handleClickOpen();
					}else if(response && response.data && response.data.responseTxt==="invalidToken"){
						window.localStorage.clear(); 
						history.push('logout');
					
					}else{
						window.location.href='testsimulator?testId='+testDetail.mocktestId+'&testType=3';

					}			 				
			}).catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})
		}		
	}
	function deleteCurrentStartNew(){		
		if(selectedCourse>=0 && mySelectedCourses[selectedCourse].templateId){
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};
			axios.get(API_URL+'/testrunningdelete?templateId='+mySelectedCourses[selectedCourse].templateId, axiosHeader)
				.then(response => {
					///console.log("Just Checking >> "+response.data);
					if(response && response.data && response.data.responseTxt==="invalidToken"){
						window.localStorage.clear(); 						
						history.push('logout');
					}			 				
			}).catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})		
			window.location.href='testsimulator?testId='+testDetail.mocktestId+'&testType=3';
		}
	}	
	function continueCurrentTest(){	
		window.location.href='testsimulator?testSession='+currentRunningTestSession+'&testType='+testType;
	}

	React.useEffect(() => {		
		if(selectedCourse>=0 && mySelectedCourses[selectedCourse].templateId){
			let diffDays = 0;
			if(localStorage.getItem('cacheDate')){
				let date1 = new Date(localStorage.getItem('cacheDate'));								
				let date2 = new Date();
				let diffTime = date2.getTime() - date1.getTime();
				diffDays = Math.round(diffTime / (1000 * 3600 * 24));
			}
			if(diffDays>0 || localStorage.getItem('templateId')!=mySelectedCourses[selectedCourse].templateId){
				getApiDataCourse(mySelectedCourses[selectedCourse].templateId);
			}
		}
	}, [selectedCourse]); 


	async function getApiDataCourse(tempId){
		setShowProgress(true);
		let axiosHeader = {
			headers:{
				'Content-Type': 'multipart/mixed',
				'loginId': etlStudentObj.loginId,
				'token': etlStudentObj.token,
				'device': 'web'
			}
		};
		///tempId=40;
		axios.get(API_URL+'/templatecache-section?templateId='+tempId, axiosHeader)
		   .then(response => {
			
			if(response.data && response.data.responseTxt==='success'){
				setShowProgress(false);

				localStorage.setItem("templateId", tempId);
				localStorage.setItem("cacheDate", new Date());

					//*********************************
					if(response.data.topicTree && response.data.topicTree.length>0){
						dispatch(setTopicTree(JSON.parse(response.data.topicTree)));
					}else{
						dispatch(setTopicTree([]));
					}
					if(response.data.topicList && response.data.topicList.length>0){
						dispatch(setTopicList(JSON.parse(response.data.topicList)));
					}else{
						dispatch(setTopicList([]));
					}
					if(response.data.keywordList && response.data.keywordList.length>0){
						dispatch(setKeywordList(JSON.parse(response.data.keywordList)));
					}else{
						dispatch(setKeywordList([]));
					}
					if(response.data.smartLearningJson && response.data.smartLearningJson.length>0){
						dispatch(setLearningContents(JSON.parse(response.data.smartLearningJson)));
					}else{
						dispatch(setLearningContents([]));
					}
					if(response.data.topicTreeLearning && response.data.topicTreeLearning.length>0){
						dispatch(setTopicTreeLearning(JSON.parse(response.data.topicTreeLearning)));
					}else{
						dispatch(setTopicTreeLearning([]));
					}
					if(response.data.topicListLearning && response.data.topicListLearning.length>0){
						dispatch(setTopicListLearning(JSON.parse(response.data.topicListLearning)));
					}else{
						dispatch(setTopicListLearning([]));
					}
					if(response.data.keywordListLearning && response.data.keywordListLearning.length>0){
						dispatch(setKeywordListLearning(JSON.parse(response.data.keywordListLearning)));
					}else{
						dispatch(setKeywordListLearning([]));
					}
					if(response.data.topicTreeTest && response.data.topicTreeTest.length>0){
						dispatch(setTopicTreeTest(JSON.parse(response.data.topicTreeTest)));
					}else{
						dispatch(setTopicTreeTest([]));
					}
					if(response.data.topicListTest && response.data.topicListTest.length>0){
						dispatch(setTopicListTest(JSON.parse(response.data.topicListTest)));
					}else{
						dispatch(setTopicListTest([]));
					}
					if(response.data.mockTestJson && response.data.mockTestJson.length>0){
						dispatch(setMockTest(JSON.parse(response.data.mockTestJson)));
					}else{
						dispatch(setMockTest([]));
					}

					if(response.data.contentLimit){
						dispatch(setContentLimit(response.data.contentLimit));
					}else{
						dispatch(setContentLimit({}));
					}
			
		    }else if(response && response.data && response.data.responseTxt==="invalidToken"){
					window.localStorage.clear(); 
					history.push('logout');
			
			} 
		})
	}

	
		return (
			<div> 
				<MetaTags>
            		<title>Select Mock Test</title>
          		</MetaTags>
				
				<Header />	
	   			<LeftDrawer />
      			<main className={classes.content}>
        		<NotificationAlerts />
				{showProgress?<LinearProgress />:null}
				<Box style={{marginBottom:100, marginLeft:20, marginRight:20}}>		

				<Box mt={1}>
						<Grid container spacing={2}>
							<Grid item   md={12} xs={12}>
								<h3 className="heading items_center" >Select Mock Test
									<StudyMaterialHelpVideoButton
									state={isHelpVideoOpen} 
									stateHandler={setIsHelpVideoOpen}
									title={"What is MY Exam Room and how to use it?"}
									link={"https://www.youtube.com/embed/w7M0oCKfUwk?si=LK9DQswWj0DU5oaT"} />
								</h3>
									
							</Grid>
						</Grid>
				</Box>				
				
				<Box mt={1}>
						<Grid container spacing={2}>
							<Grid item   md={6} xs={12} className="MuiAccordionRoot" >
							{(dataObj.mockTest && dataObj.mockTest.length>0)?dataObj.mockTest.map((myRow,index)=>(	
								<Accordion expanded={expanded === 'panel'+(index)} onChange={handleChange('panel'+(index))}>
									<AccordionSummary aria-controls={"panel"+(index)+"d-content"} id={"panel"+(index)+"d-header"} >
									<Typography>{myRow.categoryName}</Typography>
									</AccordionSummary>
									<AccordionDetails>
									<Typography>
										<ul>
											{
												myRow.testList.map((myTRow,indextt)=>(
													<li key={'intt'+indextt}><Link onClick={()=>{showDetails(myTRow)}} style={{cursor:'pointer',color:'#000'}} >{myTRow.testName}</Link></li>
												))
											}	
										</ul>
									</Typography>
									</AccordionDetails>
								</Accordion>
							)):<span><CircularProgress size={20} /> Loading...</span>}	

							</Grid>
							<Grid item   md={6} xs={12} className="test-instructions" >
								<div className="btmbdrgry"><h3>Instructions</h3></div>
								<p>
									<ol>
										<li>The clock has been set at server and count down timer at the top right corner of the screen will display left out time to closure from where you can monitor time you have to complete the exam.</li>
										<li>Click answer option buttons to select your answer.</li>
										<li>To change an answer, simply click the desired option button.</li>
										<li>Click on RESET button to deselect a chosen answer.</li>
										<li>Click on SAVE & NEXT to save the answer before moving to the next question. The next question will automatically be displayed.</li>
										<li>Click on SKIP to move to the next question without saving the current question.</li>
										<li>Click on MARK FOR REVIEW to review your answer at later stage.</li>
										<li>Make sure you click on SAVE & NEXT button everytime you want to save your answer.</li>
										<li>To go to a question, click on the question number on the right side of the screen.</li>
										<li>The color coded diagram on the right side of the screen shows the status of the questions												
												<div>
													<div><div className="qbg-not-visited-ins" style={{background:"url('"+process.env.PUBLIC_URL+"/not-visited.png')"}} >2</div> you have not visited question no 2. </div>
													<div className="qbg-ins-label" ><div className="qbg-visited-ins" style={{background:"url('"+process.env.PUBLIC_URL+"/not-answered.png')"}} >3</div> you have not answered question no 3.</div>
													<div className="qbg-ins-label" ><div className="qbg-visited-ins" style={{background:"url('"+process.env.PUBLIC_URL+"/answered.png')"}} >4</div> you have answered question no 4.</div>
													<div className="qbg-ins-label" ><div className="qbg-visited-ins" style={{background:"url('"+process.env.PUBLIC_URL+"/review.png')"}} >5</div> you have marked the question no. 5 for review.</div>
													<div className="qbg-ins-label" ><div className="qbg-visited-ins" style={{background:"url('"+process.env.PUBLIC_URL+"/answered-review.png')"}}  >6</div> you have answered & marked for review of question no. 6</div>
												</div>												
										</li>								
										<li className="clr">Candidate will be allowed to Shuffle between sections and questions anytime during the examination as per their convenience.</li>
										<li>Candidate can change their response of attempted answers anytime during the examination slot time by clicking another answer which candidates wants to change.</li>
										<li>All the answered questions(saved or marked) will be considered for calculating the final score.</li>
										<li className="redboldtxt" >Do Not PRESS any keyboard key once the exam is started.This will LOCK your exam. You can connect with the exam invigilator to unlock and continue giving the exam.</li>
										<li className="redboldtxt" >Do Not CLICK on the SUBMIT Button unless you have completed the exam.In case you click SUBMIT button, you will not be permitted to continue.</li>
									</ol>
								</p>
							</Grid>

						</Grid>
				</Box>

				

					



				</Box>
				  
				</main>
				
				<DialogTestDetails toCallStartTest={startMyTest} testDetail={testDetail} ref={childRef} />
				<DialogTestStart toCallDeleteCurrentStartNew={deleteCurrentStartNew} toCallContinueCurrentTest={continueCurrentTest} currentRunningTestTitle={currentRunningTestTitle} ref={childRefStartTest}  />		
				
				{ popup1  ? <NewTutorialButton /> : <></>}
					
			</div>
		);
 
}